document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector('.reveal-container');
  if (!container) return;

  const items = container.children;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        Array.from(items).forEach((el, i) => {
          setTimeout(() => {
            el.classList.add('active');
          }, i * 150);
        });
      }
    });
  }, { threshold: 0.3 });

  observer.observe(container);
});